import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=27f585c4&scoped=true&"
import script from "./EmailConfirm.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=27f585c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f585c4",
  null
  
)

export default component.exports